import { ReactElement } from 'react';
import Image from 'next/image';

import { CartCouponProps } from '~/types/cart';

import TagImage from '~/public/font-awesome/tag-solid.png';

export default function DealCouponLabel({
  couponLabel,
}: {
  couponLabel: CartCouponProps['description'];
}): ReactElement | null {
  if (!couponLabel) return null;

  return (
    <>
      <Image
        src={TagImage}
        height="16"
        width="16"
        alt="tag"
        className="mr-2 mt-[2px] h-4 w-4 lg:mt-0"
      />
      <span className="text-sm" data-testid="deal-coupon-label">
        {couponLabel}
      </span>
    </>
  );
}
